//  Function: isElementInViewport()
//  Author: Dustin Miller & Sarah McVicker
//  Date: 2017-01-25
//  Requires: jQuery

(function($){
  $.fn.isElementInViewport = function( options ) {

    var settings = $.extend({
        // default settings
        visibleOffset: null,
        visibleMinimum: 0
    }, options );

    var checkEl = this[0],
        rect = checkEl.getBoundingClientRect(),
        inViewportLimit = rect.bottom,
        visibleOffset = settings.visibleOffset,
        visibleMinimum = settings.visibleMinimum;

    if(visibleOffset === null ){
      if(rect.height <= (window.innerHeight * .25 || document.documentElement.clientHeight * .25)){
        visibleOffset = 1;
      }else if(rect.height <= (window.innerHeight * .8 || document.documentElement.clientHeight * .8)){
        visibleOffset = .5;
      }else{
        visibleOffset = .1;
      }
    }

    inViewportLimit = rect.top + Math.floor(rect.height * visibleOffset);
    
    if(visibleMinimum){
      if(inViewportLimit < visibleMinimum){
        inViewportLimit = visibleMinimum;
      }
    }

    return (
      rect.bottom >= 0 &&
      //rect.left >= 0 &&
      //rect.right <= (window.innerWidth || document.documentElement.clientWidth) &&
      inViewportLimit <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }; 
})(jQuery);